import { CSSProperties, memo } from 'react'

import { FormInputProps } from 'brief-form'
import { Request } from 'commons/utils/request'
import { ChoiceOption, ChoiceValue } from 'ui/types'

import { MultiSelect } from './MultiSelect'

interface Props {
  searchable?: boolean
  className?: string
  filters?: { field: string; type: string; value: ChoiceValue }[]
  emptyOption?: ChoiceOption
  disabled?: boolean
  containerStyle?: CSSProperties
  showId?: boolean
  'data-qa'?: string
  data?: ChoiceOption[]
}

export interface LicenseMultiSelectProps extends FormInputProps<ChoiceValue[] | unknown, Props> {}

const defaultProps: Partial<LicenseMultiSelectProps> = {
  searchable: true
}

export const LicenseMultiSelect = memo((props: LicenseMultiSelectProps) => {
  const {
    value,
    onChange,
    data,
    searchable,
    className,
    filters,
    emptyOption,
    disabled,
    showId = false,
    ...rest
  } = {
    ...defaultProps,
    ...props
  }

  return (
    <MultiSelect
      {...rest}
      value={value}
      onChange={onChange}
      data={data}
      placeholder="Start entering the license name"
      searchable={searchable}
      serverOptions={{
        filters,
        url: Request.urls.bank.licenseSearch,
        requestSearchString: 'searchString',
        limit: 500,
        mapper: (item) => ({
          label: showId ? `${item.name} (${item?.license_number})` : item.name,
          value: item.id
        })
      }}
    />
  )
})
